<div class="home-container">
  <div class="top-section" #section>
    <div class="upper-section">
      <div class="quote-section">
        <div class="quote">
          Fast track your career with learning tips from experts.
        </div>
        <div class="info">
          <span class="logo-name">
            The <span class="lab">Lab</span>oratory Matters</span> (TLM) is a unique platform that is curated by experts
          with a passion to teach and learn. Our team has understood the value
          and need for targeted training in order to deliver the best.
        </div>
        <div class="explore-btn">
          <button (click)="onClickExploreCourses()">Subscribe Now</button>
        </div>
      </div>
      <div class="img-section">
        <img src="../../assets/images/icon 01.png" alt="" />
      </div>
    </div>
    <div class="lower-section">
      <div class="feature-section">
        <div class="feature">
          <div class="img-section">
            <img src="../../assets/images/Content designer by expert instructors.png" alt="" />
          </div>
          <div class="content">Content designed by expert instructors and laboratory experts</div>
        </div>
        <div class="feature">
          <div class="img-section">
            <img src="../../assets/images/Self paced learning.png" alt="" />
          </div>
          <div class="content">Curated and attractive subscription bundles</div>
        </div>
        <div class="feature">
          <div class="img-section">
            <img src="../../assets/images/Relevant for your growth.png" alt="" />
          </div>
          <div class="content">Relevant for your learning for upward growth.</div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="motto-section">
    <div class="quote-icon">
      <i class="fa-solid fa-quote-left"></i>
    </div>
    <div class="motto">
      <span class="orange-R">R</span>ight test,
      <span class="orange-R">R</span>ight patient preparation,
      <span class="orange-R">R</span>ight sample,
      <span class="orange-R">R</span>ight method,
      <span class="orange-R">R</span>ight report and
      <span class="orange-R">R</span>ight interpretation.
    </div>
    <div class="quote-icon">
      <i class="fa-solid fa-quote-right"></i>
    </div>
  </div> -->
  <div class="whyus-section" #section>
    <div class="title">
      <div class="main-title yellow-heading">What is TLM</div>
      <div class="sub-title">
        <span class="logo-name">
          The <span class="lab">Lab</span>oratory Matters</span> is a one of a kind solution to modern learning.
      </div>
      <div class="sub-content">
        We help you Learn smart and work Smart.
      </div>
      <div class="sub-content">
        Continual training of laboratory personnel is vital to maintain and improve outcomes.
        At <span class="logo-name">
          The <span class="lab">Lab</span>oratory Matters</span>, our focus is on training, sharing and learning.
      </div>
    </div>
    <div class="img-section">
      <img src="../../assets/images/icon 02.png" alt="" />
      <div class="img-label">
        <div class="label1">Any where</div>
        <div class="label2">Any time</div>
        <div class="label3">At your convenience</div>
      </div>
    </div>
    <!-- <div class="content">
      <div>
        <span class="logo-name">
          The <span class="lab">Lab</span>oratory Matters</span>
        is the brainchild of laboratory experts driven by a passion to raise the
        bar of laboratory medicine across boundaries . The laboratory is
        resource intense and its outcome is a reflection of the people’s
        proficiency .
      </div>
      <div>
        A laboratory that has well-trained and insightful technologists and
        doctors is on the right path to being credible, patient centric, near
        zero error and smart. Continuous training of laboratory personnel is
        essential to maintain and improve outcomes. At
        <span class="logo-name">
          The <span class="lab">Lab</span>oratory Matters</span>, our focus is on training, sharing and learning.
      </div>
    </div> -->
    <div class="explore-btn">
      <button (click)="onClickKnowMore()">Know More</button>
    </div>
    <div class="course-quote">
      <div class="quote-icon">
        <i class="fa-solid fa-quote-left"></i>
      </div>
      <div class="quotation">
        The illiterate of 21st century will not be those who cannot read and
        write, but those who cannot
        <span class="why-us-quote">learn, unlearn and relearn.</span>
      </div>
      <div class="quote-icon">
        <i class="fa-solid fa-quote-right"></i>
      </div>
    </div>
  </div>
  <div class="teach-section" #section>
    <div class="title">
      <div class="main-title yellow-heading">What you learn at TLM</div>
      <div class="sub-title">You can unlearn, relearn and upskill.</div>
      <br>
    </div>
    <div class="content">
      <div>
        <span class="logo-name">
          The <span class="lab">Lab</span>oratory Matters</span>
        is designed to bridge the gap that exists between the classroom and the clinical laboratory. Our courses provide
        application driven learning that is tailored to meet the needs of all laboratory personnel.
      </div>
      <div>
        Learn from the expertise, mistakes and experience of laboratory medicine <br>experts at <span class="logo-name">
          The <span class="lab">Lab</span>oratory Matters</span>.
        <br>
        <br>
      </div>
    </div>
    <!-- <div class="courses">
      <div class="course" (click)="onClickCourse(course)" *ngFor="let course of topCourses; let i = index">
        <div class="name">{{ course.title }}</div>
        <div class="description">
          {{ course.description }}
        </div>
        <div class="img-section img1" *ngIf="i == 0">
          <img src="../../assets/images/icon 03.png" alt="" />
        </div>
      </div>
    </div> -->
    <div class="course-quote">
      <div class="img-section microscope">
        <img src="../../assets/images/icon 04.png" alt="" />
      </div>
      <div class="quote-icon">
        <i class="fa-solid fa-quote-left"></i>
      </div>
      <div class="quotation">
        <br>
        The essence of training is to allow error <br />without consequences. <br>
        Consequences and errors in the laboratory <br />are costly.
      </div>
      <div class="quote-icon">
        <i class="fa-solid fa-quote-right"></i>
      </div>
    </div>
    <div class="explore-btn">
      <button (click)="onClickExploreCourses()">Know More</button>
    </div>
  </div>
  <div class="testimonials-section" #section>
    <div class="title">
      <div class="main-title yellow-heading">Testimonials</div>
    </div>
    <div class="scrollable-testimonials">
      <div class="left-arrow" (click)="scrollLeft()">
        <i class="fa-solid fa-angle-left"></i>
      </div>
      <div #testimonials class="testimonials">
        <div class="testimonial">
          <div class="img-section img2">
            <img src="../../assets/images/icon 03.png" alt="" />
          </div>
          <div class="quote-left">
            <i class="fa-solid fa-quote-left"></i>
          </div>
          <div class="content">
            I have attended Dr Rani’s lectures earlier as part of CMEs. She
            explains very well and easy to follow and practice. My work at the
            lab has improved very much after learning from her.
          </div>
          <div class="quote-right">
            <i class="fa-solid fa-quote-right"></i>
          </div>
          <div class="student-name">
            <!-- <div class="label">Name :</div> -->
            <div class="name">Laboratory Technician, Chennai</div>
          </div>
        </div>
        <div class="testimonial">
          <div class="quote-left">
            <i class="fa-solid fa-quote-left"></i>
          </div>
          <div class="content">
            Dr Rani’s programs are very practical. Lot of practical tips are
            provided that I can use in my day to day reporting in the laboratory
          </div>
          <div class="quote-right">
            <i class="fa-solid fa-quote-right"></i>
          </div>
          <div class="student-name">
            <!-- <div class="label">Name :</div> -->
            <div class="name">Junior pathologist, Chennai</div>
          </div>
        </div>
        <div class="testimonial">
          <div class="quote-left">
            <i class="fa-solid fa-quote-left"></i>
          </div>
          <div class="content">
            Great clarity and difficult technical points easily explained.
            Always a pleasure to listen to Dr Rani
          </div>
          <div class="quote-right">
            <i class="fa-solid fa-quote-right"></i>
          </div>
          <div class="student-name">
            <!-- <div class="label">Name :</div> -->
            <div class="name">Laboratory Medicine expert</div>
          </div>
        </div>
        <div class="testimonial">
          <div class="quote-left">
            <i class="fa-solid fa-quote-left"></i>
          </div>
          <div class="content">
            As engineers, we find it difficult to understand the laboratory
            concepts. I attended a workshop conducted by Dr Rani where she
            explained all the basics of hematology to help me decipher the cell
            counter.
          </div>
          <div class="quote-right">
            <i class="fa-solid fa-quote-right"></i>
          </div>
          <div class="student-name">
            <!-- <div class="label">Name :</div> -->
            <div class="name">Engineer, IVD industry</div>
          </div>
        </div>
        <div class="testimonial">
          <div class="quote-left">
            <i class="fa-solid fa-quote-left"></i>
          </div>
          <div class="content">
            I have attended Dr. Savitha’s lecture on importance of quality in
            labs. After attending this program, I learnt why we get so many
            errors in my lab work. Now, I know have learnt how to implement
            quality assurance in all my work.
          </div>
          <div class="quote-right">
            <i class="fa-solid fa-quote-right"></i>
          </div>
          <div class="student-name">
            <!-- <div class="label">Name :</div> -->
            <div class="name">Laboratory supervisor, Mumbai</div>
          </div>
        </div>
      </div>
      <div class="right-arrow" (click)="scrollRight()">
        <i class="fa-solid fa-angle-right"></i>
      </div>
    </div>
  </div>
</div>
<!-- <app-signup-success></app-signup-success> -->
<!-- <app-student-management></app-student-management> -->